import { IRoleListTableLang } from '../../../types/lang'

export const roleListTableLang: IRoleListTableLang = {
	role_list_table: {
		column_id: 'ID_ua',
		column_code: 'Code_ua',
		column_name: 'Name_ua',
		column_is_buyer: 'Buyer_ua',
		column_in_group: 'Group_ua',
		column_is_team: 'Team_ua',
		column_team_report: 'Team Report_ua',
		column_permissions: 'Permissions_ua',
		column_is_system: 'System_ua',
		column_access: 'Access_ua'
	}
}